import React, {useState} from 'react';
import TransitionExpand from './TransitionExpand';
import WorkroleCert from './WorkroleCert';
import classes from './index.css';
import _ from 'lodash';

export default function CertificationBody(props){

    const [certsVisible, setCertsVisible] = useState( () => {
        var temp = {};
        Object.keys(props.certs).forEach(certid => {
            temp[certid]=false
        });
        return temp;
    });
    const [savedChildData, setSavedChildData] = useState({});

    const saveChildData = (stuff, key) => {
        var datas = _.cloneDeep(savedChildData);
        datas[key] = stuff;
        if(!_.isEqual(savedChildData, datas)) setSavedChildData(datas);
    }

    const toggleCertsVisible = (certid) => {
        var vis = _.cloneDeep(certsVisible);
        vis[`${certid}`] = !(vis[certid]);
        if(~_.isEqual(vis, certsVisible)) setCertsVisible(vis);
    }

    const shownCerts = () => {
        return Object.values(props.certs).filter( cert => certsVisible[cert.rec.id])
    }

    return(
        <div className={classes.certBody + ' ' + classes.fullwidth}>
            <h2>Certifications</h2>
            <div className={classes.buttonRow}>
                {Object.keys(props.certs).map((certId,kee) => {

                    var cert = props.certs[certId];
                    var pressedClass = certsVisible[cert.rec.id] ? classes.btnPressed : classes.btnNotPressed;
                    return(
                        <div
                            className={classes.btnLvl2 + ' ' + pressedClass}
                            key={kee}
                            onClick={() => {toggleCertsVisible(cert.rec.id)}}
                        >
                            <h3>{cert.name}</h3>
                        </div>
                    )
                })}
            </div>
            <div
                className={classes.certBody}
            >
                
                {Object.keys(props.certs).map((certId,kee) => {

                    var cert = props.certs[certId];

                    return(
                        <TransitionExpand duration={500} height={certsVisible[cert.rec.id] ? 'auto' : 0}>
                            {certsVisible[cert.rec.id] &&
                                <WorkroleCert
                                    cert={props.certs[cert.rec.id]}
                                    parentSaved={savedChildData[cert.rec.id]}
                                    //@save-please="saveChildData($event, cert.rec.id)"
                                />
                            }
                        </TransitionExpand>
                    );    
                })}

            </div>
        </div>
    )
}